// file to base 64

export function fileToBase64(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(){
          resolve(reader.result);
        };
    })
  }

  export function downloadFile(blobOrUrl) {
    if (blobOrUrl != null && navigator.msSaveBlob && typeof blobOrUrl !== 'string') {
      navigator.msSaveBlob(blobOrUrl, 'file');
      return;
    }
    const link = document.createElement('a');
    if (typeof blobOrUrl === 'string') {
      link.href = blobOrUrl;
    } else {
      link.href = window.URL.createObjectURL(blobOrUrl);
    }
    link.setAttribute('download', 'file');
    document.body.appendChild(link);
    link.click();
    if (typeof blobOrUrl !== 'string') {
      window.URL.revokeObjectURL(link.href);
    }
    document.body.removeChild(link);
  }

  // vue全局图片Url修改成缩略图形式的过滤器

  export function handleThumbnailUrl (value = '') {
    const strArr = value.split('.');
    if (strArr.length > 1) {
      const frontStr = strArr[strArr.length - 2];
      if (/_thumb$/.test(frontStr) || !(/\.[A-Za-z0-9]+$/.test(value))){
        return value;
      } else {
        return value.replace('.' + strArr[strArr.length - 1], '_thumb.' + strArr[strArr.length - 1]);
      }
    } else {
      return value;
    }
  }